import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
import ThemeContext from "./context/ThemeContext";
import "./index.css";
import { AbilityProvider } from "./context/Can";
import { QueryProvider } from "./providers/QueryProvider";
ReactDOM.render(
  <React.StrictMode>
    <QueryProvider>
      <Provider store={store}>
        <SimpleReactLightbox>
          <AbilityProvider>
            <BrowserRouter basename="/admin">
              <ThemeContext>
                <App />
              </ThemeContext>
            </BrowserRouter>
          </AbilityProvider>
        </SimpleReactLightbox>
      </Provider>
    </QueryProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
reportWebVitals();
